"use client";

import React, { useEffect, useState } from "react";
import { NavigationTabs } from "@/components/common/navigationTabs";
import { TableContainer } from "@/components/common/TableContainer";
import { Breadcrumb } from "@/components/common/Breadcrumb";
import { useAppSelector } from "@/store/hooks";
import ProductsPage from "./products";
import CollectionsPage from "./collection";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate, useParams } from "react-router-dom";

const wholesalerTabs = [
  { label: "Collections", value: "collections" },
  { label: "Products", value: "products" },
];

export default function WholesalerDetail() {
  const params = useParams();
  const navigate = useNavigate();
  const id = params.slug as string | undefined;
  const storeType = params.storeType as string;
  const storeId = params.storeId as string;

  const [activeTab, setActiveTab] = useState<string>("collections");
  const [wholesalerData, setWholesalerData] = useState<any>({});
  const { items: wholesaler } = useAppSelector((state) => state.wholesaler);

  useEffect(() => {
    if (id) {
      const data = wholesaler.find((item: any) => item.id === id);
      setWholesalerData(data || {});
    }
  }, [id, wholesaler]);

  const handleTabChange = (value: string) => setActiveTab(value);

  const handleBackClick = () => navigate(`/${storeType}/${storeId}/product/wholesaler`);
  const wholesalerName = wholesalerData?.name || wholesalerData?.Name || "Wholesaler";

  const breadcrumbItems = [
    { label: "Products", href: `/${storeType}/${storeId}/product` },
    { label: "Wholesalers", href: `/${storeType}/${storeId}/product/wholesaler` },
    { label: wholesalerName, isActive: true },
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <Button variant="outline" size="sm" onClick={handleBackClick} className="flex items-center gap-2 h-8 px-3 text-xs">
          <ChevronLeft className="h-3 w-3" />
          Back
        </Button>
        <Breadcrumb items={breadcrumbItems} showBackButton={false} />
      </div>

      <TableContainer
        navigationTabs={
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-foreground">{wholesalerName}</h1>
            <NavigationTabs
              tabs={wholesalerTabs.map((tab) => ({
                label: tab.label,
                onClick: () => handleTabChange(tab.value),
                isActive: activeTab === tab.value,
              }))}
              hasBackButton={false}
            />
          </div>
        }
      >
        {activeTab === "collections" ? (
          <CollectionsPage id={wholesalerData.id} title={wholesalerName} />
        ) : (
          <ProductsPage id={wholesalerData.id} title={wholesalerName} />
        )}
      </TableContainer>
    </div>
  );
}
